/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import { useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { contentContainer, innerScrollContainer, pageTabContainer } from './PageTab.styles'
import { Tab } from '@app/components/Molecules/Tabs'
import { Banner } from '../Banner'

interface PageTabProps {
  tabs?: Tab[]
  header?: string
  heroImageUrl?: string
  heroImageAlt?: string
  subheader?: string
  children: React.ReactNode
}

export const PageTab = ({
  children,
  header,
  subheader,
  heroImageAlt,
  heroImageUrl,
}: PageTabProps) => {
  const theme = useTheme()
  const location = useLocation()
  const scrollRef = useRef<HTMLDivElement | null>(null)

  const isGuideHomePage = location.pathname === '/app/guide/home'

  return (
    <Box css={pageTabContainer(theme)} ref={scrollRef}>
      {header && !isGuideHomePage && (
        <Banner
          header={header}
          subheader={subheader}
          heroImageAlt={heroImageAlt}
          heroImageUrl={heroImageUrl}
        />
      )}

      <Box css={contentContainer}>
        <Box css={innerScrollContainer()}>{children}</Box>
      </Box>
    </Box>
  )
}
